"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.writingStyles.disabled': 'La función de estilos de escritura no está disponible en su plan actual.',
};
